import { Provider } from '@angular/core';
import { PHARMACY_ESCRIPT_DESCRIPTORS } from './pharmacy-escript.tokens';
import { ComputAssistDescriptor } from './descriptors/computassist.descriptor';
import { DischemDescriptor } from './descriptors/dischem.descriptor';
import { EasyRxDescriptor } from './descriptors/easyrx.descriptor';

/** Registers every vendor descriptor under the registry token. Import into PatientModule providers. */
export const ESCRIPT_DESCRIPTOR_PROVIDERS: Provider[] = [
  { provide: PHARMACY_ESCRIPT_DESCRIPTORS, useExisting: DischemDescriptor, multi: true },
  { provide: PHARMACY_ESCRIPT_DESCRIPTORS, useExisting: ComputAssistDescriptor, multi: true },
  { provide: PHARMACY_ESCRIPT_DESCRIPTORS, useExisting: EasyRxDescriptor, multi: true },
];
